import { Text } from "@ab.uitools/ui-library/components/Text";
import { useMemo } from "react";

interface Props {
  amount: number;
  className?: string;
}

export const ExchangeRateAmount = ({ amount, className }: Props) => {
  const exchangeAmount = useMemo(() => {
    const int = amount ? Math.trunc(amount).toLocaleString() : "00";
    const float = amount.toString().split(".")?.[1];
    return {
      int,
      float,
    };
  }, [amount]);

  return (
    <div
      className={`flexbox align-items--center ${className}`}>
      <Text type="primary" size="medium" className="flexbox" weight="bold">
        {exchangeAmount.int}
      </Text>
      {exchangeAmount.float && (
        <Text
          size="medium"
          weight="bold"
          type="tertiary"
        >
          .{exchangeAmount.float}
        </Text>
      )}
    </div>
  );
};
